import { useAanraakscherm, useSmalScherm } from "@fawkes/ui";

/**
 * Draait dit scherm op telefoonformaat? Dezelfde grens als mobile.css (768 pixels), zodat opmaak en
 * gedrag niet uit elkaar kunnen lopen: wat de opmaak anders neerzet, weet de code ook.
 *
 * Gebruik dit voor indeling. Voor bediening die op een aanraakscherm anders moet — slepen,
 * dubbelklikken — hoort {@link useAanraken}: een tablet is breed én wordt met een vinger bediend.
 */
export function useMobiel(): boolean {
  return useSmalScherm();
}

/**
 * Wordt dit scherm met een vinger bediend? Voor alles wat op een aanraakscherm niet bestaat,
 * ongeacht de breedte — een tablet valt hieronder, een smal browservenster op een desktop niet.
 *
 * De haken zelf wonen in @fawkes/ui, omdat DataTable ze daar ook nodig heeft en één implementatie
 * beter is dan twee die kunnen gaan verschillen. Deze namen blijven bestaan omdat de schermen in
 * deze app ze zo kennen.
 */
export function useAanraken(): boolean {
  return useAanraakscherm();
}
